import Icon from 'veui/components/Icon'

Icon.register({
  'hand-shaking': {
    paths: [
      {
        d: 'M731.61 242.83L632.74 98.48A132 132 0 00430.5 79.74l-46.76 46.76-46.42-46.42A132 132 0 00135 98.92L36.24 243.41a162.08 162.08 0 0019.19 206L312.84 706.8a99.72 99.72 0 00141 0L682.1 478.54a31.9 31.9 0 004.61-3.82l25.8-25.79a162.07 162.07 0 0019.1-206.1zM591.06 479.07l-78-78a28 28 0 00-39.6 39.59l78 78-30.46 30.5-104.77-104.75a28 28 0 00-39.6 39.59l104.75 104.75-30.49 30.49-78-78a28 28 0 00-39.6 39.59l78 78-2.7 2.7a35.71 35.71 0 01-50.5 0l-257.41-257.4a98 98 0 01-11.6-124.6L187.85 135a68 68 0 01104.22-9.7l46.41 46.41-113 113a32 32 0 000 45.25 141.82 141.82 0 00200.57 0l35.31-35.3 157 157zm76.19-75.4l-3.17 3.17-157.43-157.43 9.11-9.11a32 32 0 10-45.25-45.3l-31.73 31.74-57.92 57.93a78 78 0 01-82.6 17.79l108.1-108.08L475.75 125a68 68 0 01104.19 9.66L678.81 279a98 98 0 01-11.56 124.67z'
      }
    ],
    width: '768',
    height: '768'
  }
})
